;(function($, undefined){

    var rnn = window.rnn,
        quoteTemplate;

    //Create a quote
    function createQuote(quote, cite){

        var $newQuote;

        //Create the elements from scratch exactly once, then clone in the future.
        //Note: this can be generated with $("<blockquote>..") if we really want to save filesize.
        quoteTemplate = quoteTemplate || (function(){
            var blockQuote = document.createElement("blockquote"),
                banner = document.createElement("div"),
                bannerIcon = document.createElement("span"),
                quoteP = document.createElement("p"),
                cite = document.createElement("cite");

            banner.appendChild(bannerIcon);
            blockQuote.appendChild(banner);
            blockQuote.appendChild(quoteP);
            blockQuote.appendChild(cite);

            return blockQuote;
        })();

        $newQuote = $(quoteTemplate.cloneNode(true));

        $newQuote.find("p").html(quote);
        $newQuote.find("cite").html(cite);

        return $newQuote;
    }

    // Initialise Quotes
    function initQuotes() {

        var $quotes = $('.newsEntry > blockquote');

        $quotes.each(function(){
            var $this = $(this),
                cite = $this.find("cite").remove(),
                quote = $this.html();

            if ($this.find(":not(p,span,a,em,strong)").length === 0) {
                $this.replaceWith(createQuote(quote, cite.html()));
            }

        });

    }

    rnn.modules.register("quotes", {
        init: initQuotes
    });

})(jQuery);
